// Restores the global `regeneratorRuntime` that CRA/Babel used to inject.
// Prebuilt @stashinvest/ui components (e.g. QuestionTree's QuestionForm) reference
// it as a bare global; without this Vite leaves it undefined and they throw at runtime.
import 'regenerator-runtime/runtime';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import Router from 'stash/routes';
import {
	SnackbarProvider,
	ThemePreferenceProvider,
	ThemeProvider,
} from '@stashinvest/ui';
import { BanjoProvider } from '@stashinvest/react-banjo';
import { isProd } from 'stash/utils';
import { languageMap } from 'banjo';
import {
	ExperimentsContextUpdater,
	getLaunchDarklyProvider,
} from 'stash/components/ab-testing';
import { SdsNavProvider } from '@stashinvest/react-components';
import { Link } from 'react-router-dom';
import { getAnalyticsInstance } from 'stash/initializers/analytics';
import { AnalyticsProvider } from 'stash/contexts/analytics';
import { initializeStore } from 'stash/initializers/store';
import { createBrowserHistory } from 'history';
import { NativeAuthProvider } from 'stash/components/native-auth-provider/NativeAuthProvider';
import { initDatadogRum } from 'stash/utils/datadogRum';

initDatadogRum();

const isLocalhost = window.Stash.env === '__STASH_ENV__';

// If you need to change API locally, update your .env file.
if (!isProd() && !isLocalhost) {
	const customAPI = localStorage && localStorage.getItem('stashAPI');

	if (customAPI) {
		window.Stash.CUSTOM_API_PATH = customAPI;
	}
}

function App() {
	const analytics = getAnalyticsInstance();
	const history = createBrowserHistory();
	const store = initializeStore({ history, analytics });

	return (
		<AnalyticsProvider analytics={analytics}>
			<Provider store={store}>
				<NativeAuthProvider>
					<ExperimentsContextUpdater />
					<SdsNavProvider linkComponent={Link}>
						<ThemePreferenceProvider>
							<ThemeProvider>
								<BanjoProvider
									defaultLocale="en-us"
									languageMap={languageMap}
									variants={[]}
								>
									<SnackbarProvider>
										<Router history={history} />
									</SnackbarProvider>
								</BanjoProvider>
							</ThemeProvider>
						</ThemePreferenceProvider>
					</SdsNavProvider>
				</NativeAuthProvider>
			</Provider>
		</AnalyticsProvider>
	);
}

(async () => {
	const LaunchDarklyProvider = await getLaunchDarklyProvider();

	const root = createRoot(document.getElementById('root'));
	root.render(
		<LaunchDarklyProvider>
			<App />
		</LaunchDarklyProvider>
	);
})();
